 export const BACKEND_URL = 'https://api.tunecast.com';
//export const BACKEND_URL = 'http://localhost:3005';
export const WSS_URL = 'https://realtime.tunecast.com';
// export const WSS_URL = 'http://localhost:3020';
